import { Elements } from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js'
import { ScrollToTop } from 'components'
import routes from 'config/routes'
import 'core-js/stable'
import React from 'react'
import ReactDOM from 'react-dom'
import { IntlProvider } from 'react-intl'
import { Provider } from 'react-redux'
import { BrowserRouter as Router, Route } from 'react-router-dom'
import App from './App'
import store from './config/store'
import * as serviceWorker from './serviceWorker'
import './styles/index.scss'

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY)

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <IntlProvider locale='en' defaultLocale='en'>
        <Router basename='/support'>
          <Route path={routes.base}>
            <Elements stripe={stripePromise}>
              <ScrollToTop />
              <App />
            </Elements>
          </Route>
        </Router>
      </IntlProvider>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
